export default "__VITE_ASSET__BOiLbfmT__"